import { render, staticRenderFns } from "./PageSingleSelect.vue?vue&type=template&id=67dd2430"
import script from "./PageSingleSelect.vue?vue&type=script&lang=js"
export * from "./PageSingleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports